/**
 * InviteSignupShell Component
 * Shared green-bg layout wrapper used across invite-style signup flows
 * (Care-Seeker invite, sub-delegate signup, etc.).
 */

import SignupBackground from '@/assets/login_background.png';

export type InviteSignupShellProps = {
  children: React.ReactNode;
};

export const InviteSignupShell = ({ children }: InviteSignupShellProps) => (
  <div className="bg-[#026857]">
    <main className="bg-[#026857] md:container py-12 flex max-md:flex-col items-center gap-16">
      <section className="md:w-2/4 py-12 max-md:container">{children}</section>

      <section className="rounded-2xl p-2 max-md:mb-24">
        <img
          src={SignupBackground}
          alt="signup_background"
          className="rounded-2xl bg-cover bg-center w-full flex-1"
        />
      </section>
    </main>
  </div>
);
